import {
  REFRESH_USER_CUSTOMERS,
  SELECT_CUSTOMER,
  CHANGE_CUSTOMER_STATUS,
  SET_CUSTOMER_DATA,
  SET_VIEW_CUSTOMER,
  SET_CUSTOMER_LIST,
} from '../actions/constants'

const initialState = {
  customerType: 'SFDA',
  customerStatus: true,
  refreshCustomerList: false,
  customerData: {},
  setCustomerView: false,
  customerList: [],
}

export default function (state = initialState, action) {
  switch (action.type) {
    case SELECT_CUSTOMER:
      return {
        ...state,
        customerType: action.payload,
      }
    case SET_CUSTOMER_LIST:
      return {
        ...state,
        customerList: action.payload,
      }
    case CHANGE_CUSTOMER_STATUS:
      return {
        ...state,
        customerStatus: action.payload,
      }
    case REFRESH_USER_CUSTOMERS:
      return {
        ...state,
        refreshCustomerList: action.payload,
      }
    case SET_CUSTOMER_DATA:
      return {
        ...state,
        customerData: action.payload,
      }
    case SET_VIEW_CUSTOMER:
      return {
        ...state,
        setCustomerView: action.payload,
      }
    default:
      return {
        ...state,
      }
  }
}
